import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { Link, Text, Box } from '@applyboard/crystal-ui';
var ProgramInfo = function ProgramInfo(props) {
  var program = props.program;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Link, {
    href: "".concat(window.location.origin).concat(program.programLink),
    mode: "override_user_choice_and_open_in_new_tab",
    variant: "standalone"
  }, program.name), /*#__PURE__*/React.createElement(Text, {
    variant: "bodyM"
  }, program.school));
};
export default ProgramInfo;